import { SxProps, Theme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { assessmentPhoneLandscapeMedia } from "../assessment-layout-styles";

export const containerStyle = (isFinish: boolean): SxProps<Theme> => ({
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: isFinish ? "column" : "row",
    md: isFinish ? "column" : "row",
  },
  alignItems: "center",
  justifyContent: "center",
  alignSelf: { xs: "center", sm: "center", md: "center" },
  flexShrink: 0,
  minWidth: 0,
});

export const circularContainerStyle: SxProps<Theme> = {
  position: "relative",
  display: "inline-flex",
  mt: { xs: "0", sm: "0", md: "0" },
};

export const circularProgressStyle: SxProps<Theme> = {
  color: "#06B6D41A",
  "& .MuiCircularProgress-circle": {
    stroke: "#06B6D4",
  },
};

export const circularProgressOverlayStyle: SxProps<Theme> = {
  position: "absolute",
  color: "#06B6D41A",
  "& .MuiCircularProgress-circle": {
    stroke: "#06B6D41A",
  },
};

export const circularTextContainerStyle = (theme: Theme): SxProps<Theme> => ({
  top: "10%",
  left: "10%",
  bottom: "10%",
  right: "10%",
  position: "absolute",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "50%",
  backgroundColor: alpha(theme.palette.quizPopap.quizBg, 0.94),
  zIndex: 1,
  overflow: "hidden",
  px: "4px",
});

export const circularTextStackStyle: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "1px",
  maxWidth: "100%",
  minWidth: 0,
};

export const circularTextStyle = (
  isFinish: boolean,
  showWideFormat = false,
  isCompactTablet = false,
  hasBonus = false,
): SxProps<Theme> => {
  const fontSize = hasBonus
    ? isFinish
      ? "12px"
      : isCompactTablet
        ? "10px"
        : "11px"
    : showWideFormat
      ? isFinish
        ? "11px"
        : isCompactTablet
          ? "11px"
          : "10px"
      : isFinish
        ? "13px"
        : isCompactTablet
          ? "11px"
          : "11px";

  return {
    color: "#06B6D4",
    fontWeight: 700,
    fontSize,
    lineHeight: 1.1,
    fontFamily: "monospace",
    fontVariantNumeric: "tabular-nums",
    whiteSpace: "nowrap",
    textAlign: "center",
    maxWidth: "100%",
    [assessmentPhoneLandscapeMedia]: {
      fontSize: hasBonus ? "8px" : showWideFormat ? "8px" : "9px",
    },
  };
};

export const circularBonusTextStyle = (
  isFinish: boolean,
  isCompactTablet = false,
): SxProps<Theme> => ({
  color: "#06B6D4",
  fontWeight: 600,
  fontSize: isFinish ? "9px" : isCompactTablet ? "7px" : "8px",
  lineHeight: 1.1,
  fontFamily: "monospace",
  fontVariantNumeric: "tabular-nums",
  whiteSpace: "nowrap",
  textAlign: "center",
  maxWidth: "100%",
  opacity: 0.92,
  [assessmentPhoneLandscapeMedia]: {
    fontSize: "7px",
  },
});

export const resultsContainerStyle = (isFinish: boolean): SxProps<Theme> => ({
  ml: { xs: "0", sm: isFinish ? "0" : "8px", md: "16px" },
  mt: { xs: 0, sm: isFinish ? "16px" : "0", md: isFinish ? "12px" : "0" },
  display: "flex",
  flexDirection: "column",
  alignItems: {
    xs: "center",
    sm: isFinish ? "center" : "flex-start",
    md: isFinish ? "center" : "flex-start",
  },
  justifyContent: "center",
  textAlign: {
    xs: "center",
    sm: "center",
    md: isFinish ? "center" : "left",
  },
  whiteSpace: { xs: "normal", sm: "nowrap", md: "nowrap" },
  minWidth: 0,
});

export const correctAnswersTextStyle = (
  isFinish: boolean,
  theme: Theme,
): SxProps<Theme> => ({
  display: { xs: "none", sm: "block" },
  fontWeight: 600,
  color: isFinish ? theme.palette.quizPopap.quizText : "#06B6D4",
  fontSize: { xs: "14px", sm: "14px", md: "16px" },
  whiteSpace: { xs: "normal", sm: "nowrap", md: "nowrap" },
});
